import React from 'react'
import { useFormContext } from 'react-hook-form'
import { FormatLabel } from './format-label'
import { useFormDefaultValue, useFormSetValue } from './hooks/input-hooks'

export const FormHidden = ({ name, value, required, defaultValue, valueAsNumber, shouldDirty }) => {
  const { register } = useFormContext()

  useFormDefaultValue(name, defaultValue, shouldDirty)
  useFormSetValue(name, value, shouldDirty)

  return (
    <FormatLabel>
      <input className="form-control" type="hidden" {...register(name, { required, valueAsNumber })} />
    </FormatLabel>
  )
}
